import React,{useEffect} from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Title from './Title';
import {OnlineCostPer} from './Inc';
import IntroArt from './imgs/intro_art.png';
import IntroBook from './imgs/intro_book.png';

const About = ()=> {
    const classes = useStyles();
    useEffect(()=>{
        window.scrollTo(0,0);
    },[]);    
    return (
        <div id="about" className={classes.root+" "+classes.policy}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper className={classes.paper} id="p1_pos">
						<Title text="架空ストアとは？" icon="store"/>
						<div className="firstTalk">
							<p>架空ストアへようこそ！架空ストアでは新しい作家さんをいつも募集しています。</p>
							<p>ここでしか見つからないとっておきの商品をあなたも作ってみませんか？</p>
							<p>そういう「何か」が欲しいお客さんとそういうお客さんに出会いたい作家さんを、架空ストアはお待ちしています。</p>
						</div>
						<Grid container spacing={2}>
							<Grid item xs={12} md={1}>

							</Grid>
							<Grid item xs={12} md={10}>
								<div className="storeTheme">
									<h3>当店の概要</h3>
									<ol>
										<li>オリジナルオンリーのオンラインストアです。</li>
										<li>販売手数料（{OnlineCostPer}％）は商品が売れた時だけいただきます。</li>
										<li>作家登録から納品書の作成まで全てオンラインで可能です。</li>
										<li>ご注文の受付から商品の発送、代金の回収まで全て架空ストアに任せられます。</li>
										<li>販売開始から一定期間は抽選販売になりますので、お客様にゆっくりと商品を選んでいただけます。</li>
										<li>商品の売上はリアルタイムで確認可能です。</li>
										<li>納品受付は商品到着から1営業日以内。すぐに販売を開始できます。</li>
									</ol>
								</div>
							</Grid>
							<Grid item xs={12} md={1}>

							</Grid>

							<Grid item xs={12} md={5}>
								<div style={{padding:"1em"}}>
									<Title text="作品をお預かりする委託販売"/>
									<div>
										<p>架空ストアは、作家さんから作品をお預かりして販売する委託販売です。</p>
										<p>ご購入者への商品の発送や、お客様とのやりとりは全て架空ストアが行いますので、作家さんは作品の創作に専念することができます。</p>
									</div>
								</div>
							</Grid>
							<Grid item xs={12} md={7}>
								<div style={{padding:"1em"}}>
									<Title text="手続きはすべてインターネットで"/>
									<div>
										<p>架空ストアはオンラインストアです。商品登録は作家さん自身の手でオンラインで行えるようになっています。</p>
										<p>本・雑貨の場合と、戯曲（電子書籍）の場合では、商品の登録方法に若干違いはありますが、 作家としてのプロフィールの登録や、売上の確認方法など、基本的な部分は共通になっています。</p>
									</div>
								</div>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
				<Grid item xs={12} md={6}>
					<Paper className={classes.paper}>
						<Title text="本・雑貨"/>
						<div style={{textAlign:"center"}}>
							<img src={IntroArt} style={{maxWidth:"100%"}}/>
						</div>
						<div style={{marginBottom:"2em"}}>
							<p>このオンラインショップをじっくりとご覧になっていただいて、あなたの作風や性格に合う雰囲気だなと思ったら、ぜひご検討ください。</p>
							<p>初めて作品をお預かりする際には、事前審査をさせていただいております。事前審査なしで作品のお預かりはできませんのであらかじめご了承ください。</p>
						</div>
						<Divider/>
						<div className="moreText">
							<Link to="/inquiry"><Button variant="text" color="primary"><ArrowForwardIcon/>お問い合わせ</Button></Link><br/>
							<Link to="/first/input"><Button variant="text" color="primary"><ArrowForwardIcon/>事前審査</Button></Link><br/>
							<Link to="/profile"><Button variant="text" color="primary"><ArrowForwardIcon/>作家登録</Button></Link>
						</div>
					</Paper>
				</Grid>
				<Grid item xs={12} md={6}>
					<Paper className={classes.paper}>
						<Title text="戯曲" second="（電子書籍）"/>
						<div style={{textAlign:"center"}}>
							<img src={IntroBook} style={{maxWidth:"100%"}}/>
						</div>
						<div style={{marginBottom:"2em"}}>
							<p>プロ・アマチュア問わず、著作権に問題のない自作の戯曲をお持ちの作家さんであれば、どなたでもご利用になれます。作品のジャンルや上演の有無、上演時間の長さも問いません。</p>
							<p>戯曲の原稿を簡単に電子書籍のデータに変換できるシステムが用意されています。実際にどんな要領で作成されるのか、そしてどんなものができあがるのか、ぜひ試してみて下さい。</p>
						</div>
						<Divider/>
						<div className="moreText">
							<Link to="/inquiry"><Button variant="text" color="primary"><ArrowForwardIcon/>お問い合わせ</Button></Link><br/>
							<Link to="/profile"><Button variant="text" color="primary"><ArrowForwardIcon/>作家登録</Button></Link><br/>
						</div>
					</Paper>
				</Grid>
				<Grid item xs={12}>

					<Paper className={classes.paper}>
						<Title text="営業日時間と休業日" icon="store"/>
						<div className="firstTalk">
							<p>
								原則として24時間365日いつでもお買い物が可能になっています。SideBでの作業（商品登録や売上の確認など）も同様です。<br/>
								<span className="helper">※サーバーのトラブルやメンテナンスなどで臨時休業する場合はあります。</span>
							</p>
						</div>

						<div style={{marginBottom:"4em"}}>
							<Title text="休業日" size={2}/>
							<div style={{marginBottom:"2em"}}>
								ただし、商品発送などスタッフの手作業が必要となる業務については以下のような休業日がございます。
							</div>
							<div className="company">
								<table>
									<thead>
										<tr>
											<th>作業内容</th>
											<th>休業日</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												・商品の発送<br/>
												・ご入金の確認<br/>
												・事前審査の返信<br/>
												・納品の受付<br/>
												・お問い合わせの返信<br/>
												など
											</td>
											<td>
												火曜日<br/>
												年末年始<br/>
											</td>
										</tr>
									</tbody>
								</table>
								<p className="helper">※都合により臨時休業する場合もあります。</p>
							</div>
						</div>
					</Paper>
				</Grid>
			</Grid>
        </div>
    )
}

export default About;